module.exports = __webpack_public_path__ + "static/media/img-3.49af593d.jpg";